import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user\"><path d=\"M513.641903 273.924105m-273.924105 0a273.924105 273.924105 0 1 0 547.848209 0 273.924105 273.924105 0 1 0-547.848209 0Z\" fill=\"#C2C1C1\" p-id=\"2685\" /><path d=\"M371.617317 612.977018h280.765366A338.505612 338.505612 0 0 1 990.888295 951.48263v72.51737H33.111705v-72.51737A338.505612 338.505612 0 0 1 371.617317 612.977018z\" fill=\"#C2C1C1\" p-id=\"2686\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol